import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module LocationsSaga
 */

/**
 *
 * @param {object} payload data has locationData
 */
export function setLocationsData(data) {
  store.dispatch({
    type: actionTypes.ADD_LOCATIONS_DATA,
    payload: {
      data
    }
  });
}
export function addUserDistance() {
  store.dispatch({
    type: actionTypes.ADD_USER_DISTANCE
  });
}
export function setUserLocation(currentLocation) {
  store.dispatch({
    type: actionTypes.SET_USER_LOCATION,
    payload: {
      currentLocation
    }
  });
}

export function setSelectedLocation(data) {
  store.dispatch({
    type: actionTypes.ADD_SELECTED_LOCATION,
    payload: {
      data
    }
  });
}
